import React from 'react';
import styles from './landinghero.module.css';
import profile_pic from '../resources/images/profile_pic_tr.png';

import { Circle, HalfCircle, FilledCircle, FilledHalfCircle } from './Shapes';

export default function LandingHero() {
    
    return <div className={styles.main}>
        <div className={styles.sideRect} />
        <div className={styles.content}>
            <div className={styles.textContainer}>
                <h1 className={styles.introMessage} 
                    style={{paddingBottom:0, marginBottom:0}}>
                    {/* Hi! I'm Tudor */}
                    HI! I'M TUDOR
                </h1> 
                <p className={styles.introSubtitle}>
                    Canberra based Software Developer 🐨 
                </p>
            </div>
            <div style={{margin:0, flex:1, zIndex:2}}>
                <img className={styles.profile_pic} src={profile_pic} alt="profile_pic" />
            </div>
        </div>
        
        {/* Top Left Circle */}
        <FilledHalfCircle 
            size={350}
            color={'var(--tertiary-color-a)'}
            style={{
                top:0, left: -125,
                transform: 'rotateX(-180deg)'}}/>

        {/* Bottom Middle Circle */}
        <FilledHalfCircle 
            size={250}
            color={'var(--primary-bg-color)'}
            style={{bottom:0, right: 'calc(50vw)'}}/>    
        <Circle 
            size={80}
            color={'var(--tertiary-color-a)'}
            style={{bottom:90, right: 'calc(40vw + 110px)'}}/>
        {/* Bottom Middle (Below) Circle */}
        <FilledHalfCircle 
            size={250}
            color={'var(--secondary-bg-color)'}
            style={{
                bottom:-125, right: '30vw',
                transform: 'rotateX(-180deg)'
            }}/>

  </div>;
}
